import { gql } from "@apollo/client";

const GET_ORDERS = gql`
  query orders(
  $params: QueryParams
  $startDate: Date
  $endDate: Date
  ) {
    orders(
    params: $params
    startDate: $startDate
    endDate: $endDate
    ) {
      info {
        count
      }
      results {
        id
        status
        price
        createdAt
      }
    }
  }
`;

const GET_ORDERS_DAILY_SUMMARY = gql`
  query OrdersDailySummary($startDate: String!, $endDate: String!) {
    ordersDailySummary(startDate: $startDate, endDate: $endDate) {
      date
      ordersCount
      totalRevenue
    }
  }
`;

const GET_CLIENTS = gql`
  query GetClients($params: QueryParams, $search: String, $location: QueryOperators, $startDate: Date, $endDate: Date) {
    clients(params: $params, search: $search, location: $location, startDate: $startDate, endDate: $endDate) {
      results {
        id
        user {
          firstName
          lastName
        }
        moneySpent
      }
    }
  }
`;

export { GET_ORDERS, GET_ORDERS_DAILY_SUMMARY, GET_CLIENTS };
